import React from 'react';
import TogglesGenerator, { TYPES } from './TogglesGenerator';

function NormalToggleWithText(props) {
    return <TogglesGenerator type={TYPES.NORMAL_WITH_TEXT} {...props} />
}

NormalToggleWithText.displayName = 'NormalToggleWithText';

export default NormalToggleWithText;
